module.exports = __webpack_public_path__ + "static/img/mopaasbanner-m.3d8c88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mopaasbanner-m.png
// module id = Rnxc
// module chunks = 0